// @flow
import React, { Component, Fragment, type Node } from 'react';
import EmptyTable from '../../../../../components/EmptyTable';
import TableLoader from '../../../../../components/TableLoader';
import { type FailedMerchant } from '../../../../../utilities/types';
import { Mobile, Tablet } from '../../../../../components/Responsive';
import FailedMerchantsTableRow from './FailedMerchantsTableRow';
import FailedMerchantDetailRow from './FailedMerchantDetailRow';
import { history } from '../../../../../utilities/history';

type Props = {
  deleteFailedMerchant: (failedMerchantId: number, showModal: ?boolean) => void,
  failedLoad: boolean,
  loading: boolean,
  expandRow: (id: number) => void,
  failedMerchants: FailedMerchant[],
  expandedRowId: ?number,
  initializeForm: (value: string, {}) => void
};

export default class FailedMerchantsTableBody extends Component<Props> {
  handleEditClick = (merchant: FailedMerchant) => {
    const diff_mailing_address =
      merchant.mailing_address_address ||
      merchant.mailing_address_city ||
      merchant.mailing_address_state ||
      merchant.mailing_address_zip ||
      merchant.mailing_address_country_code
        ? 'yes'
        : 'no';
    this.props.initializeForm('verification', {
      user: {
        first_name: merchant.first_name,
        last_name: merchant.last_name,
        email: merchant.email,
        phone_number: merchant.phone_number
      },

      company_detail_attributes: {
        company_name: merchant.company_name,
        dba: merchant.dba,
        address_attributes: {
          address: merchant.address_address,
          city: merchant.address_city,
          state: merchant.address_state,
          zip: merchant.address_zip,
          country_code: merchant.address_country_code
        },
        description: merchant.description,
        processing_volume_id: merchant.processing_volume,
        website: merchant.website,
        type_of_company: merchant.type_of_company
      },
      mailing_address_attributes: {
        address_attributes: {
          address: merchant.mailing_address_address,
          city: merchant.mailing_address_city,
          state: merchant.mailing_address_state,
          zip: merchant.mailing_address_zip,
          country_code: merchant.mailing_address_country_code
        }
      },
      company_contact_attributes: {
        administrative_name: merchant.administrative_contact_name,
        administrative_phone: merchant.administrative_contact_phone,
        administrative_email: merchant.administrative_contact_email
      },
      failed_merchant_application_id: merchant.id,
      diff_mailing_address
    });
    history.push('/merchants/registrations/form/1');
  };

  renderDetailRow = (merchant: FailedMerchant, colSpan: number) => (
    <FailedMerchantDetailRow
      merchant={merchant}
      colSpan={colSpan}
      deleteFailedMerchant={this.props.deleteFailedMerchant}
      initializeForm={this.props.initializeForm}
      handleEditClick={this.handleEditClick}
    />
  );

  render() {
    if (this.props.failedLoad) {
      // $FlowFixMe
      return <EmptyTable error columns={6} />;
    } else if (this.props.loading) {
      return <TableLoader columns={6} />;
    } else if (this.props.failedMerchants.length === 0) {
      return (
        <EmptyTable
          title="Nothing To See Here"
          columns={6}
          img="thumbsUp"
          text="There are no failed merchant appplications that need your attention."
        />
      );
    }

    return (this.props.failedMerchants.map(merchant => {
      const expanded = merchant.id === this.props.expandedRowId;
      return (
        <Fragment key={merchant.id}>
          {/* TODO: Edit Row. Form should clear after user navigates away from merchant registrations. */}
          <FailedMerchantsTableRow
            merchant={merchant}
            expandRow={this.props.expandRow}
            expanded={expanded}
            deleteFailedMerchant={this.props.deleteFailedMerchant}
            handleEditClick={this.handleEditClick}
            initializeForm={this.props.initializeForm}
          />
          {expanded && (
            <>
              <Mobile>{this.renderDetailRow(merchant, 2)}</Mobile>
              <Tablet>{this.renderDetailRow(merchant, 3)}</Tablet>
            </>
          )}
        </Fragment>
      );
    }): Node);
  }
}
